/** @description API Config */
export const API_BASE_URL = process.env.API_BASE_URL;
export const API_VERSION = process.env.API_VERSION;
export const API_VERSION_V2 = process.env.API_VERSION_V2;
export const API_VERSION_V3 = process.env.API_VERSION_V3;
export const REQUEST_TIMEOUT = 10.5 * 1000;

/** @description API 응답 성공 코드 */
export const DEFAULT_SUCCESS_CODE = '0000';

/** @description Axios 에러 상태 코드 */
export const FORBIDDEN_ERROR_STATUS = '403';
export const UNAUTHORIZED_ERROR_STATUS = '401';
export const TIMEOUT_ERROR_CODE = 'ECONNABORTED';

/** @description API 응답 에러 메세지 */
export const COMMON_ERROR_MESSAGE_SYNTAX_ERROR = '예기치 못한 에러가 발생했어요. 다시 시도해주세요.';
export const COMMON_ERROR_MESSAGE_INTERNAL_SERVER_ERROR =
  '서버에 예기치 못한 에러가 발생했어요. 관리자에게 문의해 주세요.';
export const COMMON_ERROR_MESSAGE_TIMEOUT = '요청 시간이 초과되었어요. 다시 시도해주세요.';

/** @description API 응답 에러코드 */
export const COMMON_CUSTOM_ERROR_CODE = '9999';
export const COMMON_SYNTAX_ERROR_CODE = 'COMMON_0000';

export const COMMON_INTERNAL_SERVER_ERROR_CODE = ['COMMON_0001', 'COMMON_0002'];

// LA.. (Login/Auth)
export const EXPIRED_PASSWORD_ERROR_CODES = ['LA001', 'LA002']; // 비밀번호 변경(만료/강제변경) 대상
export const INCORRECT_LOGIN_ID_OR_PASSWORD_ERROR_CODE = 'LA003'; // 아이디/비밀번호 불일치
export const INCORRECT_OR_ALREADY_USED_PASSWORD_ERROR_CODE = 'LA004'; // 현재 비번 불일치 또는 과거 사용 비번
export const MISMATCH_PHONE_NUMBER_ERROR_CODE = 'LA006'; // 아이디는 있으나 휴대폰 번호 불일치
export const NOT_FOUND_OR_ALREADY_USED_PHONE_NUMBER_ERROR_CODE = 'LA007'; // 휴대폰 번호 없음 또는 이미 사용됨
export const NOT_FOUND_LOGIN_ID_ERROR_CODE = 'LA008'; // 존재하지 않는 아이디
export const INCORRECT_CURRENT_PASSWORD_ERROR_CODE = 'LA016'; // 현재 비밀번호 불일치

// LP.. (개인정보)
export const MISMATCH_ACCOUNT_NAME_ERROR_CODE = 'LP000'; // 예금주명 ↔ 작업자명 불일치
export const NOT_FOUND_ACCOUNT_NUMBER_ERROR_CODE = 'LP001'; // 은행/계좌번호 조회 불가
export const INVALID_JUMIN_NUMBER_ERROR_CODE = 'LP002'; // 주민등록번호 형식/값 무효

// VC.. (인증)
export const EXPIRED_VERIFICATION_ERROR_CODE = 'VC001'; // 인증번호 만료
export const INCORRECT_VERIFICATION_ERROR_CODE = 'VC002'; // 인증번호 불일치

// EEC.. (근태)
export const INVALID_LEAVE_TIME_ERROR_CODE = 'EEC003'; // 조퇴 시간 무효

// K.. (토큰)
export const INVALID_REFRESH_TOKEN_ERROR_CODE = 'K401'; // 리프레시 토큰 무효

// WP.. (공정)
export const NOT_FOUND_QR_CODE_ERROR_CODE = 'WP000'; // 존재하지 않는 공정 정보
export const INVALID_QR_CODE_ERROR_CODE = 'WP001'; // 유효하지 않은 QR 코드
export const FAILED_CHECK_IN_AND_OUT_ERROR_CODE = 'WP002'; // 체크인/아웃 실패

// PT.. (패스토큰)
export const NOT_FOUND_PASS_TOKEN_ERROR_CODE = 'PT001'; // 발급된 passToken을 찾을 수 없음
export const REQUIRED_PASS_TOKEN_ERROR_CODE = 'PT002'; // passToken 누락
export const INVALID_PASS_TOKEN_ERROR_CODE = 'PT003'; // passToken 불일치
